
<div class="m-multi-row" [formGroup]="liability">
	<div class="form-row row">
	<button type="button" *ngIf="displayX" 
		class="close" 
		aria-label="Close" 
		(click)="removed.emit(index)">
		<span aria-hidden="true">&times;</span>
	</button>
		<div class="form-group col-12 col-lg-4">
			<div *ngIf="index===0" class="text-right m-title">				
				{{"LIABILITIES.QUESTION2.LIABILITY_TYPE"|translate}}
			</div>
			<select formControlName="liabilityType" 					
				[attr.id]="'liabilityType'+index" 
				(change)="udateValue()"
				class="form-control m-sm-form-control my-auto"
				[attr.aria-label]="'LIABILITIES.QUESTION2.LIABILITY_TYPE'|translate">
				<option disabled [defaultSelected]=true [value]="defaultValue">{{"LIABILITIES.QUESTION2.LIABILITY_TYPE_PH"|translate}}</option>
				<option *ngFor="let type of types" [value]="type">{{type}}</option>
			</select>
			<div class="m-error" *ngIf="liability.get('liabilityType').hasError('required') && displayErrors">
					{{ 'COMMON.FIELD_REQUIRED_FROM_LIST' | translate }}
			</div>
		</div>
		<div class="form-group col-12 col-lg-4">
				<div *ngIf="index===0" class="text-right m-title">				
						{{"LIABILITIES.QUESTION2.LIABILITY_BALANCE"|translate}}
				</div>
			<input currencyMask
						placeholder="{{'LIABILITIES.QUESTION2.LIABILITY_BALANCE'|translate}}"
						formControlName="liabilityBalance"
						type="tel" 
						[attr.id]="'liabilityBalance'+index"
						class="my-auto form-control m-sm-form-control"
						[attr.aria-label]="'LIABILITIES.QUESTION2.LIABILITY_BALANCE'|translate"/>
			<div class="m-error" *ngIf="!(liability.get('liabilityType').value === 'שכר דירה') &&!(liability.get('liabilityType').value === 'מזונות') && liability.get('liabilityBalance').hasError('required') && displayErrors">
					{{ 'COMMON.FIELD_REQUIRED' | translate }}
			</div>
		</div>
		<div class="form-group col-12 col-lg-4">
			<div *ngIf="index===0" class="text-right m-title">				
					{{"LIABILITIES.QUESTION2.MONTHLY_REFUND"|translate}}
			</div>
			<input currencyMask
						placeholder="{{'LIABILITIES.QUESTION2.MONTHLY_REFUND'|translate}}"
						formControlName="liabilityMonthlyRefund"
						type="tel"
						[attr.id]="'liabilityMonthlyRefund'+index"
						class="my-auto form-control m-sm-form-control"
						[attr.aria-label]="'LIABILITIES.QUESTION2.MONTHLY_REFUND'|translate"/>
			<div class="m-error" *ngIf="liability.get('liabilityMonthlyRefund').hasError('required') && displayErrors">
					{{ 'COMMON.FIELD_REQUIRED' | translate }}
			</div>
		</div>
</div>
</div>




// WEBPACK FOOTER //
// ./src/app/add-liability/add-liability.component.html